import React from 'react';
import './StatCaption.less';

export const StatCaption = ({text}) => {
	return <span className="stat-caption">{text}</span>;
};
